import React from 'react';
import styles from './success-screen.module.scss';
import Button from '../../../../common/ekedc-components/button/Button';

interface SuccessScreenProps {
  title: string;
  subtitle?: string;
  onContinue: () => void;
  onClose?: () => void;
  buttonText?: string;
  secondaryButtonText?: string;
  onSecondary?: () => void;
  icon?: React.ReactNode;
  imageSrc?: string;
  imageAlt?: string;
  className?: string;
  children?: React.ReactNode;
}

export const SuccessScreen: React.FC<SuccessScreenProps> = ({
  title,
  subtitle,
  onContinue,
  onClose,
  buttonText = 'Continue',
  secondaryButtonText,
  onSecondary,
  icon,
  imageSrc,
  imageAlt = '',
  className = '',
  children,
}) => {
  const hasSecondary = !!(secondaryButtonText && onSecondary);
  return (
    <div className={`${styles.overlay} ${className}`}>
      <div className={styles.popup}>
        {onClose && (
          <button
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}

        <div className={styles.content}>
          {imageSrc ? (
            <img src={imageSrc} alt={imageAlt} className={styles.image} />
          ) : (
            <div className={styles.iconContainer}>
              {icon || (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <path
                    d="M16 24L22 30L32 18"
                    stroke="white"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </div>
          )}

          <div className={styles.textContainer}>
            <h1 className={styles.title}>{title}</h1>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
          {children}
        </div>

        <div className={styles.buttonContainer}>
          {hasSecondary && (
            <Button variant="secondary" className={styles.actionButton} onClick={onSecondary}>
              {secondaryButtonText}
            </Button>
          )}
          <Button variant="primary" className={hasSecondary ? styles.actionButton : ''} onClick={onContinue}>
            {buttonText}
          </Button>
          
        </div>
      </div>
    </div>
  );
};
